export const ratingError = 'Rating is required';
export const complianceError = 'You must select this checkbox to submit the review';
export const validateUserComplianceField = value => {
  if (value) return;
  return complianceError;
};
export const validateRatings = value => {
  if (value) return;
  return ratingError;
};
export const validateOnSubmit = data => {
  const {
    userHasComplianceConsent,
    ratings
  } = data;
  const errors = {};
  if (!userHasComplianceConsent) {
    errors.userHasComplianceConsent = complianceError;
  }
  if (!ratings) {
    errors.ratings = ratingError;
  }
  return errors;
};